module.exports = __webpack_public_path__ + "static/media/waycaytion.3552de8b.png";